'use strict'

import { computed } from 'vue'
import type { ComputedRef } from 'vue'
import set from 'lodash/set'

interface FormData {
  datas?: Record<string, unknown>
  [key: string]: unknown
}

interface FormField {
  value: ComputedRef<unknown>
  hasValue: ComputedRef<boolean>
  parseValue: (value: unknown) => unknown
}

export function useFormField(
  formData: FormData | null | undefined,
  fieldName: string,
  typeValue: string | null = null,
): FormField {
  function parseValue(value: unknown): unknown {
    let parsed: unknown = value
    if (typeValue === 'int') {
      if (Array.isArray(value)) {
        parsed = value
          .map((v: unknown): unknown => {
            if (v === '') {
              return v
            }
            if (Number.isNaN(parseInt(String(v)))) {
              return v
            }
            return parseInt(String(v))
          })
          .filter((v: unknown): boolean => v !== '')
      } else {
        if (value === null || value === '') {
          parsed = null
        } else {
          parsed = parseInt(String(value))
        }
      }
    }
    return parsed
  }

  const value = computed({
    get(): unknown {
      if (formData?.datas && fieldName in formData.datas) {
        return formData.datas[fieldName]
      }
      return null
    },
    set(v: unknown): void {
      if (!formData || !fieldName) {
        return
      }
      const target: Record<string, unknown> = formData.datas || (formData as Record<string, unknown>)
      set(target, fieldName, v)
    },
  })

  const hasValue = computed((): boolean => {
    const val: unknown = value.value
    return val !== null && val !== undefined && val !== ''
  })

  return {
    value,
    hasValue,
    parseValue,
  }
}
